const KpiMultiCards = ({ cards }) => {
  return (
    <div className="row kpi-card-container">
      {cards?.map((card) => (
        <KpiCard
          key={card?.title}
          title={card?.title ?? ''}
          value={card?.value ?? 0}
          percentageSpan={card?.percentageSpan ?? null}          
          iconContent={card?.iconContent}
          extraContent={card?.extraContent}
        />
      ))}
    </div>
  )
}

const KpiCard = ({
  iconContent = <i className="fas fa-id-badge colorOrange" />,
  title = '',
  value = '',
  extraContent = null,
  percentageSpan = null,
}) => {
  return (
    <div className="kpi-card">
      <div className="kpi-card-header">
        <span className="kpi-icon icon-primary">{iconContent}</span>
      </div>
      <div className="kpi-card-body">
        <h6>{title}</h6>
        <p className="kpi-value">
          {value}
          {percentageSpan && percentageSpan}    
        </p>
        {extraContent && extraContent}        
      </div>
    </div>
  )
}

export default KpiMultiCards
